// import "particles.js";
import { Navbar } from "./Navbar";
import { SocialIcons } from './SocialIcons';
import wasif_img from "./../assets/wasif0.webp";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { TypeAnimation } from 'react-type-animation';
import { Helmet } from "react-helmet-async";



export function About() {
  // useEffect(() => { 
  //   window.particlesJS("particles-js", {
  //     particles: {
  //       number: {
  //         value: 480,
  //         density: {
  //           enable: true,
  //           value_area: 2000,
  //         },
  //       },
  //       color: {
  //         value: "#4da7ce",
  //         opacity: 0,
  //       },
  //       shape: {
  //         type: "circle",
  //         stroke: {
  //           width: 2,
  //           color: "#71858d",
  //           opacity: 0,
  //         },
  //         polygon: {
  //           nb_sides: 2,
  //         },
  //       },
  //       opacity: {
  //         value: 0.1,
  //         anim: {
  //           enable: false,
  //         },
  //       },
  //       size: {
  //         value: 2,
  //         random: true,
  //         anim: {
  //           enable: false,
  //         },
  //       },
  //       line_linked: {
  //         enable: true,
  //         distance: 100,
  //         color: "#5ecaf4",
  //         opacity: 0.5,
  //         width: 1,
  //       },
  //       move: {
  //         enable: true,
  //         speed: 6,
  //         out_mode: "out",
  //       },
  //     },
  //     interactivity: {
  //       detect_on: "canvas",
  //       events: {
  //         onhover: { enable: true, mode: "grab" },
  //         onclick: { enable: true, mode: "push" },
  //       },
  //       modes: {
  //         grab: { distance: 140, line_linked: { opacity: 0.5 } },
  //         push: { particles_nb: 4 },
  //       },
  //     },
  //     retina_detect: true,
  //   });

  //   return () => {
  //     const particlesCanvas = document.getElementById("particles-js");
  //     if (particlesCanvas) particlesCanvas.innerHTML = "";
  //   };
  // }, []);

  const { t, i18n } = useTranslation();
  const [sequence, setSequence] = useState([]);
  const [key, setKey] = useState(0);
  useEffect(() => {
    const translatedSequence = t("about.heading", { returnObjects: true });
    setSequence(translatedSequence)
    setKey((prevKey) => prevKey + 1);
  }, [i18n.language, t])

  return (
    <div className="text-white relative lg:px-0">
      <Helmet>
        <title>Hire Team Lead & Solution Architect | MVP Developer UK - Wasif Shehzad</title>
        <meta name="description" content="Team Lead & Solution Architect serving UK/USA. 30+ MVPs delivered. Build your product in 4-8 weeks with React, Python, Node.js & AI integration." />
        <meta name="author" content="Wasif Shehzad" />

        {/* Open Graph Tags */}
        <meta property="og:title" />
        <meta property="og:description" />
        <meta property="og:image" content={wasif_img} />
        <meta property="og:url" content="https://wasif-shehzad.github.io/me/about" />
        <meta property="og:type" content="profile" />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:site_name" content="Wasif Shehzad - Portfolio" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" />
        <meta name="twitter:description" />
        <meta name="twitter:image" content={wasif_img} />
        <meta name="twitter:creator" content="@wasifshehzad" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://wasif-shehzad.github.io/me/about" />
      </Helmet>
      <div
        id="particles-js"
        style={{ position: "absolute", width: "100%", height: "100%", zIndex: -1 }}
      ></div>

      <Navbar />
      <div className="mt-6 lg:mt-0" style={{ position: "relative", zIndex: 1 }}>
        <p className="w-[85%] m-auto text-xl text-center font-bold lg:py-8 md:text-4xl lg:text-5xl">
          <TypeAnimation
            key={key}
            sequence={sequence}
            wrapper="span"
            speed={20}
            deletionSpeed={0}
            omitDeletionAnimation={true}
            repeat={0}
          />
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center px-4 py-10">
        <div className="flex justify-center items-center mb-10 md:mb-0 md:w-4/12">
          <img
            className="rounded-full w-40 md:w-56 lg:w-96 border-2 border-[#5ecaf4]"
            src={wasif_img}
            alt="Wasif Shehzad"
          />
        </div>

        <div className="text-center md:text-left md:w-9/12 md:px-6">
          <h1 className="font-arial text-xl md:text-2xl lg:text-3xl font-extrabold text-white">
            {t("about.name")}
          </h1>
          <h2 className="font-arial  text-sm md:text-lg lg:text-xl font-semibold">
            {t("about.title")}
          </h2>

          <div className="text-sm text-justify px-2 lg:px-0 md:text-base lg:text-lg text-white mt-4 lg:pr-24">
            <p>{t("about.description")}</p>
            <p className="py-4">{t("about.description1")}</p>
          </div>
          <SocialIcons />
        </div>
      </div>


      <div style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        height: '0',
        overflow: 'hidden'
      }}>
        <h1>Team Lead & Solution Architect - Wasif Shehzad</h1>
        <h2>Technical Leadership & MVP Development Services for UK and USA Startups</h2>

        <h3>Team Leadership Services</h3>
        <p>
          Professional <strong>Team Lead</strong> providing technical leadership and team management for development projects.
          <strong>Solution Architect</strong> services for designing scalable systems and technical strategy.
          Available for <strong>UK startups</strong> in <strong>London, Manchester, Birmingham</strong> and <strong>USA businesses</strong> in <strong>New York, San Francisco, Los Angeles</strong>.
        </p>

        <h3>MVP Development Expertise</h3>
        <p>
          <strong>30+ MVPs successfully delivered</strong> for startups and enterprises.
          Specializing in <strong>React.js applications, Python backend systems, Node.js development, and AI integration</strong>.
          <strong>4-8 week delivery timeline</strong> for minimum viable products with <strong>scalable architecture</strong>.
        </p>

        <h3>Technical Skills & Technologies</h3>
        <p>
          <strong>Team Lead</strong> with expertise in <strong>React, Python, Node.js, TypeScript, Next.js, AWS, and AI technologies</strong>.
          <strong>Solution Architecture</strong> for <strong>web applications, mobile apps, AI systems, and cloud infrastructure</strong>.
          <strong>Technical leadership</strong> for development teams and project management.
        </p>

        <h3>Service Locations & Coverage</h3>
        <p>
          <strong>Team Lead London</strong>, <strong>Solution Architect Manchester</strong>, <strong>Technical Lead Birmingham</strong>,
          <strong>MVP Developer Leeds</strong>, <strong>AI Specialist Glasgow</strong>, <strong>React Developer Bristol</strong>,
          <strong>Python Expert Edinburgh</strong>, <strong>Node.js Developer Liverpool</strong>, <strong>Tech Consultant Sheffield</strong>,
          <strong>Web Development Newcastle</strong>, <strong>Full-Stack Developer New York</strong>, <strong>Solution Architect San Francisco</strong>,
          <strong>Team Lead Los Angeles</strong>, <strong>AI Integration Chicago</strong>, <strong>MVP Developer Austin</strong>,
          <strong>React Expert Seattle</strong>, <strong>Python Developer Boston</strong>, <strong>Node.js Specialist Miami</strong>,
          <strong>Tech Consultant Denver</strong>, <strong>Web Development Dallas</strong>, <strong>Technical Lead Washington DC</strong>,
          <strong>Solution Architect San Diego</strong>.
        </p>

        <h3>Industry Expertise</h3>
        <p>
          <strong>Startup technology partner</strong>, <strong>SaaS development</strong>, <strong>AI integration services</strong>,
          <strong>web application development</strong>, <strong>mobile app development</strong>, <strong>cloud architecture</strong>,
          <strong>technical consulting</strong>, <strong>team leadership</strong>, <strong>project management</strong>,
          <strong>system design</strong>, <strong>API development</strong>, <strong>database architecture</strong>.
        </p>

        <h3>Key Achievements</h3>
        <p>
          <strong>50+ MVP projects delivered</strong>, <strong>4-8 week development cycles</strong>,
          <strong>UK and USA client base</strong>, <strong>React.js expertise</strong>, <strong>Python development</strong>,
          <strong>Node.js backend systems</strong>, <strong>AI integration projects</strong>, <strong>AWS cloud solutions</strong>,
          <strong>team leadership experience</strong>, <strong>solution architecture</strong>, <strong>technical strategy</strong>.
        </p>

        <h3>Hire Technical Leadership</h3>
        <p>
          Looking to <strong>hire Team Lead UK</strong> or <strong>Solution Architect USA</strong>?
          Professional <strong>technical leadership services</strong> for <strong>React projects, Python applications, Node.js systems, and AI integration</strong>.
          <strong>30+ successful deliveries</strong> for <strong>startups and enterprises</strong> in <strong>United Kingdom and United States</strong>.
        </p>
      </div>
    </div>
  );
}




